"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.themeOptions = exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _colors = require("@material-ui/core/colors");
var _colors2 = require("../colors");
var _shadows = _interopRequireDefault(require("../shadows"));
var _typography = _interopRequireDefault(require("../typography"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var themeOptions = {
  breakpoints: {
    keys: ['xs', 'sm', 'md', 'lg', 'xl'],
    values: {
      lg: 1280,
      md: 960,
      sm: 600,
      xl: 1920,
      xs: 0
    }
  },
  direction: 'ltr',
  mixins: {
    toolbar: {
      '@media (min-width:0px) and (orientation: landscape)': {
        minHeight: 48
      },
      '@media (min-width:600px)': {
        minHeight: 56
      },
      minHeight: 56
    }
  },
  overrides: {
    MuiAppBar: {
      colorPrimary: {
        background: _colors2.primary.main
      }
    },
    MuiButton: {
      containedPrimary: {
        '&:active': {
          backgroundColor: _colors2.opacity.primary[800][62]
        },
        '&:hover': {
          backgroundColor: _colors2.opacity.primary[800][86]
        },
        boxShadow: 'none'
      },
      outlinedPrimary: {
        '&$disabled': {
          borderColor: _colors2.opacity.black[14]
        },
        '&:active': {
          backgroundColor: _colors2.opacity.primary[800][24]
        },
        '&:hover': {
          backgroundColor: _colors2.opacity.primary[800][8],
          borderColor: _colors2.opacity.black[14],
          boxShadow: 'none'
        },
        borderColor: _colors2.opacity.black[14],
        color: _colors2.primary.main
      },
      root: {
        '&:active': {
          backgroundColor: _colors2.opacity.black[14]
        },
        '&:hover': {
          boxShadow: _shadows["default"][5]
        },
        borderRadius: '2px',
        height: '36px',
        minWidth: '88px',
        padding: '0 16px',
        textTransform: 'uppercase'
      },
      sizeLarge: {
        fontSize: '14px',
        padding: '0 16px'
      },
      sizeSmall: {
        fontSize: '12px',
        height: '32px',
        minWidth: '72px',
        padding: '0 8px'
      },
      textPrimary: {
        '&$disabled': {
          borderColor: _colors2.opacity.black[38]
        },
        '&:active': {
          backgroundColor: _colors2.opacity.primary[800][24]
        },
        '&:focus, &:hover': {
          boxShadow: 'none'
        },
        '&:hover': {
          backgroundColor: _colors2.opacity.primary[800][8]
        },
        color: _colors2.primary.main
      }
    },
    MuiCheckbox: {
      root: {
        '&:active': {
          background: _colors2.opacity.black[14]
        },
        '&:hover': {
          background: _colors2.opacity.black[8]
        },
        height: 32,
        padding: 0,
        width: 32
      }
    },
    MuiChip: {
      clickable: {
        '&:active, &:focus': {
          backgroundColor: _colors2.opacity.black[24],
          boxShadow: 'none'
        },
        '&:hover': {
          backgroundColor: _colors2.opacity.black[14]
        }
      },
      deleteIcon: {
        marginLeft: '8px',
        marginRight: '8px'
      },
      icon: {
        marginLeft: '8px',
        marginRight: '8px'
      },
      label: {
        paddingLeft: 0,
        paddingRight: 0
      },
      outlined: {
        border: "1px solid ".concat(_colors2.opacity.black[60]),
        color: _colors2.opacity.black[87]
      },
      root: {
        backgroundColor: _colors2.opacity.black[8],
        color: _colors2.opacity.black[87],
        minWidth: '36px'
      }
    },
    MuiCircularProgress: {
      root: {
        color: _colors2.primary.main
      }
    },
    MuiDivider: {
      root: {
        backgroundColor: _colors2.opacity.black[14],
        margin: "".concat(8 / 2, "px 0")
      }
    },
    MuiFormControlLabel: {
      root: {
        marginLeft: -7
      }
    },
    MuiFormLabel: {
      root: {
        color: _colors2.opacity.black[38]
      }
    },
    MuiInput: {
      underline: {
        '&:after': {
          borderBottom: "2px solid ".concat(_colors2.primary[700])
        },
        '&:before': {
          borderBottom: "1px solid ".concat(_colors2.opacity.black[14])
        },
        '&:hover:not($disabled):not($focused):not($error):before': {
          borderBottom: "2px solid ".concat(_colors2.opacity.black[60])
        }
      }
    },
    MuiInputLabel: {
      shrink: {
        transform: 'none'
      }
    },
    MuiLinearProgress: {
      bar: {
        backgroundColor: _colors2.primary.main
      },
      bar1Indeterminate: {
        width: 168
      },
      bar2Indeterminate: {
        width: 168
      },
      colorPrimary: {
        backgroundColor: _colors.lightBlue[100]
      },
      root: {
        height: 4,
        width: 360
      }
    },
    MuiMenuItem: {
      root: _objectSpread({}, _typography["default"].body, {
        height: '12px',
        minHeight: 'auto'
      })
    },
    MuiSnackbar: {
      anchorOriginBottomCenter: {
        '@media (min-width: 960px)': {
          bottom: 24
        }
      }
    },
    MuiSnackbarContent: {
      action: {
        '& > *': {
          marginRight: '8px'
        },
        background: 'inherit',
        marginLeft: 'auto',
        marginRight: 0,
        padding: 0,
        paddingLeft: 0
      },
      message: {
        alignItems: 'center',
        display: 'flex',
        margin: '0 16px',
        maxHeight: 'inherit',
        overflow: 'hidden'
      },
      root: {
        '@media (max-width: 959.9px)': {
          maxHeight: 68,
          maxWidth: 640,
          minHeight: 48,
          minWidth: 240
        },
        '@media (min-width: 960px)': {
          maxHeight: 68,
          maxWidth: 640,
          minHeight: 48,
          minWidth: 240
        },
        background: _colors2.greyscale[900],
        borderRadius: 2,
        boxShadow: _shadows["default"][9],
        display: 'flex',
        flexWrap: 'nowrap',
        justifyContent: 'start',
        maxHeight: 68,
        maxWidth: 640,
        minHeight: 48,
        minWidth: 240,
        padding: '6px 0'
      }
    },
    MuiSwitch: {
      colorPrimary: {
        '&$disabled': {
          color: _colors.common.white
        }
      },
      root: {
        '&$checked': {
          '&:active': {
            background: _colors2.opacity.primary[800][14]
          },
          '&:hover': {
            background: _colors2.opacity.primary[800][8]
          },
          '&disabled': {
            '& $track': {
              color: 'red'
            }
          }
        },
        '&$disabled': {
          '&$switchBase': {
            color: 'red'
          }
        }
      },
      switchBase: {
        '&$checked': {
          '&:active': {
            background: _colors2.opacity.primary[800][14]
          },
          '&:hover': {
            background: _colors2.opacity.primary[800][8]
          }
        },
        '&$checked + $track': {
          opacity: 0.38
        },
        '&$disabled': {
          '& + $track': {
            opacity: 0.38
          },
          '&$checked': {
            '& + $track': {
              backgroundColor: _colors2.primary.main
            },
            color: _colors2.primary.main
          },
          color: _colors.common.white
        },
        '&:active': {
          background: _colors2.opacity.black[14]
        },
        '&:hover': {
          background: _colors2.opacity.black[8]
        },
        color: _colors.common.white,
        height: 32,
        left: 4,
        padding: 6,
        top: 3,
        width: 32
      },
      thumb: {},
      track: {}
    },
    MuiTab: {
      root: {
        paddingBottom: 0
      }
    },
    MuiTableCell: {
      root: {
        minWidth: '124px',
        paddingLeft: 16,
        paddingRight: 16
      }
    }
  },
  palette: {
    accent: _colors2.accent,
    action: _colors2.action,
    background: _colors2.background,
    contrastThreshold: 3,
    divider: _colors2.opacity.black[14],
    error: _colors2.error,
    greyscale: _colors2.greyscale,
    opacity: _colors2.opacity,
    // new property added to theme
    primary: _colors2.primary,
    secondary: _colors2.secondary,
    success: _colors2.success,
    text: _colors2.text,
    tonalOffset: 0.2,
    type: 'light',
    white: _colors.common.white
  },
  progress: {
    color: _colors.common.black
  },
  props: {
    MuiButtonBase: {
      disableRipple: true,
      disableTouchRipple: true
    }
  },
  shadows: _shadows["default"],
  shape: {
    borderRadius: 4
  },
  spacing: 8,
  transitions: {
    // disable animation by default
    // reference: https://material-ui.com/getting-started/faq/#how-can-i-disable-animations-globally
    create: function create() {
      return 'none';
    }
  },
  typography: _typography["default"],
  zIndex: {
    appBar: 1100,
    drawer: 1200,
    mobileStepper: 1000,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
  }
};
exports.themeOptions = themeOptions;
var _default = themeOptions;
exports["default"] = _default;